export class Util {
  constructor({ $api }) {
    this.api = $api;
  }

  jobId(payload) {
    return this.api.dispatch('util/jobId', payload);
  }
}

export default (ctx, inject) => {
  inject('util', new Util(ctx));
};
